import {getThumbnailImage, getBrandLogo} from "@irati/utils/images/getImageSize/getImageSize"
import companyBenefitsFallbackLogo from "@irati/ui/images/company-benefits-fallback.png"
import {BRAND_LOGO_SQUARE_DIMENSIONS} from "@irati/brand/constants/brand"
import hasUploadedLogo from "@irati/identity/helpers/tenant/hasUploadedLogo"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"
import {benefitsSchemeSettings} from "./settings"

export const getCompanyBenefitsLogo = (branding) => {
  const {logoUrl} = benefitsSchemeSettings()
  let imageUrl

  if (logoUrl) {
    imageUrl = logoUrl
  } else if (hasUploadedLogo()) {
    imageUrl = branding && branding.businessLogoUrl
  }

  if (imageUrl) {
    return getBrandLogo(imageUrl, BRAND_LOGO_SQUARE_DIMENSIONS.width, BRAND_LOGO_SQUARE_DIMENSIONS.height, 100, {crop: "pad"})
  }
  return companyBenefitsFallbackLogo
}

export const determineDealThumbnailImage = (deal, branding) => {
  const isCompanyBenefitsDeal = deal.type === DEAL_TYPE_COMPANY_BENEFITS
  if (isCompanyBenefitsDeal) {
    return getCompanyBenefitsLogo(branding)
  }
  return getThumbnailImage(deal.thumbnailImage)
}

export const determineDealColor = (deal, tenantImageUrl, tenantColor) => {
  const isCompanyBenefitsDeal = deal.type === DEAL_TYPE_COMPANY_BENEFITS
  if (isCompanyBenefitsDeal) {
    return hasUploadedLogo() ? tenantColor || null : "#F4A583"
  }
  return null
}

export const getBenefitsSchemeHeader = () => {
  const settings = benefitsSchemeSettings()
  return settings.name || null
}
